import { getCssSizeValue, getHtmlFromRedactorField, getMapKey, getPaddingsClassFromData } from "@/utils/utils"
import styled from "styled-components"
import Text from "@/components/common/Text"
import ArrowsNavigation from "@/components/common/ArrowsNavigation"
import useEmblaCarousel from "embla-carousel-react"
import Tile from "@/components/FactsModule/Tile"
import { usePrevNextArrowButtons } from "@/components/Banners/Home/hooks"

const Container = styled.div`
	background: ${({ theme }) => theme.colors.richBlue};
	padding-top: ${getCssSizeValue(96)};
	padding-bottom: ${getCssSizeValue(80)};
`

const TopBar = styled.div`
	padding: 0 var(--paddingX);
	display: flex;
	justify-content: space-between;
	color: ${({ theme }) => theme.colors.platinum};
	text-transform: capitalize;
	margin-bottom: ${getCssSizeValue(116)};
`

const EmblaViewPort = styled.div`
	overflow: hidden;
	padding: 0 var(--paddingX);
	height: 77vh;
	cursor: pointer;
`

const EmblaContainer = styled.div`
	backface-visibility: hidden;
	display: flex;
	touch-action: pan-y pinch-zoom;
`

function getData(src) {
	return {
		id: src?.id || "",
		buttonText: src?.buttonText || "",
		header: src?.header || "",
		paddings: getPaddingsClassFromData(src),
		items: src?.items || [],
	}
}

export default function FactsModule({ data }) {
	const { id, buttonText, header, paddings, items } = getData(data)

	const [emblaRef, emblaApi] = useEmblaCarousel({
		align: "start",
		dragFree: true,
	})

	const { onPrevButtonClick, onNextButtonClick } = usePrevNextArrowButtons(emblaApi)

	return (
		<div className={paddings}>
			<Container>
				<TopBar>
					<Text className="typo-borna-114" dangerouslySetInnerHTML={getHtmlFromRedactorField(header)} />
					<ArrowsNavigation
						boxText={buttonText}
						leftButtonClickHandler={onPrevButtonClick}
						rightButtonClickHandler={onNextButtonClick}
					/>
				</TopBar>
				<EmblaViewPort ref={emblaRef}>
					<EmblaContainer>
						{items.map((item) => (
							<Tile key={getMapKey(item, id)} item={item} />
						))}
					</EmblaContainer>
				</EmblaViewPort>
			</Container>
		</div>
	)
}
